import { ddMMyyyyhhmmANoIST, ddMMyyyyHHmm, ddMMyyyyhhmmA } from '@fareye/utils'
import { IColumn, IColumnConfig } from '../utility/types'
import { dateFormatter as dateFormatterTimezone } from '@fareye/common'

export const HEADER_INFLECTION = {
  headers: { 'Key-Inflection': 'camel', 'X-Change-Case': true }
}
function dateFormatter(val: any) {
  return val
    ? typeof val == 'object'
      ? dateFormatterTimezone(val, 'YYYYMMDDHHmmz')
      : ddMMyyyyHHmm(val)
    : ''
}
function dateFormatterIST(val: any) {
  return val ? ddMMyyyyhhmmANoIST(val) : ''
}
function dateFormatterUTC(val: any) {
  return val
    ? typeof val == 'object'
      ? dateFormatterTimezone(val, 'YYYYMMDDHHmmz')
      : ddMMyyyyhhmmA(val)
    : ''
}
function dateFormatterTz(val: any): any {
  return val ? dateFormatterTimezone(val, 'YYYYMMDDHHmmz') : ''
}
function precision(val: any, place = 2) {
  if (!val) {
    return ''
  } else {
    return Number(val).toFixed(place)
  }
}

function precision2(val: any) {
  return precision(val, 2)
}
function precision4(val: any) {
  return precision(val, 4)
}

export const formatters: any = {
  dateFormatter,
  dateFormatterIST,
  dateFormatterUTC,
  dateFormatterTz,
  precision2,
  precision4
}
// Config for Child User config

export const Columns: IColumn[] = [
  {
    label: 'Name',
    key: 'name'
  },
  {
    label: 'Phone No.',
    key: 'primaryPhoneNo'
  },
  {
    label: 'Email',
    key: 'email'
  },
  {
    label: 'Filter Name',
    key: 'filterName'
  },
  {
    label: 'Filter Applicable on',
    key: 'type'
  },
  {
    label: 'State',
    key: 'state'
  },
  {
    label: 'Action',
    key: 'action'
  },
  {
    label: 'First Name',
    key: 'firstName'
  },
  {
    label: 'Last Name',
    key: 'lastName'
  }
]

export const defaultCRUDAccess = {
  isAddAllowed: false,
  isUpdateAllowed: false,
  isDeleteAllowed: false
}

export const initialState = {
  data: [],
  isLoading: false,
  isSuccess: true,
  isError: false,
  message: '',
  meta: {}
}

export const DEVICE_CONFIG = {
  devices: '/api/v3/map_imei/devices',
  deviceHistoryPathParam: '/api/v3/map_imei/device/device_histories',
  deviceUpload: '/api/v3/map_imei/devices/import_devices',
  exportDevice: '/streams/map_imei/devices/export_data'
}

export const TRIP_CLOSURE = {
  trip_close: '/api/v3/consigner_trip/close_trips',
  journey_close: '/api/v3/journeys/close_journeys'
}

export const POI_CONFIG = {
  defaultPoiConfig: '/api/v3/admin/default_poi_configs',
  defaultPoiConfigTypes:
    '/api/v3/admin/default_poi_configs/fetch_config_default',
  poiConfig: '/api/v3/admin/poi_configs',
  poiConfigTypes: '/api/v3/admin/poi_configs/fetch_config_default'
}

export const POI_COLUMNS = [
  {
    label: 'Id',
    key: 'id'
  },
  {
    label: 'Identifier',
    key: 'identifier'
  },
  {
    label: 'Value',
    key: 'value'
  },
  {
    label: 'Lat',
    key: 'lat'
  },
  {
    label: 'Lng',
    key: 'lng'
  },
  {
    label: 'Radius',
    key: 'radius'
  },
  {
    label: 'Poi Id',
    key: 'poiId'
  },
  {
    label: 'User Id',
    key: 'userId'
  },
  {
    label: 'Type',
    key: 'Type'
  },
  {
    label: 'Poi Type',
    key: 'poiType'
  },
  {
    label: 'Mode of creation',
    key: 'modeOfCreation'
  },
  {
    label: 'Created At',
    key: 'createdAt',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'Updated At',
    key: 'updatedAt',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'Lat Lng List',
    key: 'latLngList'
  },
  {
    label: 'Action',
    key: 'action'
  },
]

export const POI_FORM_RENDERING= {
  label: 'Poi Config',
  formKey: 'poiForm',
  options: {},
  desc: 'Use this form to create poi config',

  styles: {},
  formConfig: {
    '1': {
      data: [
        {
          formKey: 'identifier',
          validation: 'required',
          label: 'Identifier',
          type: 'local-select',
          placeholder: 'Select Identifier',
          apiUrl: '/api/v3/admin/poi_configs/fetch_config_default?type=identifier',
          options: null,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          searchQueryKey: 'content'
        },
        {
          formKey: 'value',
          validation: 'required',
          label: 'Value',
          type: 'text',
          placeholder: 'Enter Value',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'lat',
          validation: null,
          label: 'Lat',
          type: 'text',
          placeholder: 'Enter Lat',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'lng',
          validation: null,
          label: 'Lng',
          type: 'text',
          placeholder: 'Enter  Lng',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'radius',
          validation: null,
          label: 'Radius',
          type: 'text',
          placeholder: 'Enter radius',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'poiId',
          validation: null,
          label: 'Poi Id',
          type: 'text',
          placeholder: 'Enter Poi Id',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'Type',
          validation: "required",
          label: 'Type',
          type: 'local-select',
          placeholder: 'Select',
          apiUrl: '/api/v3/admin/poi_configs/fetch_config_default?type=_type',
          options: null,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          searchQueryKey: 'content'
        },
        {
          formKey: 'poiType',
          validation: null,
          label: 'Poi Type',
          type: 'local-select',
          placeholder: 'Select',
          apiUrl: '/api/v3/admin/poi_configs/fetch_config_default?type=poi_type',
          options: null,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          searchQueryKey: 'content'
        },
        {
          formKey: 'latLngList',
          validation: null,
          label: 'Lat lng list',
          type: 'text',
          placeholder: 'Ex-  17.12323,78.23223 : 17.8989,79.0912 : 18.0232, 77.8989',
          row: 1,
          styling: { variant: { width: [1, 1 , 1 ] } },
          dependency: null,
          options: null
        },
      ],
      style: {}
    },
  },
  btnConfig: {
    submitButton: {
      label: 'Submit',
      style: {},
      isDisplay: true
    },
    resetButton: {
      isDisplay: true,
      label: 'Reset',
      style: {}
    }
  }
}

export const DEFAULT_POI_COLUMNS = [
  {
    label: 'Id',
    key: 'id'
  },
  {
    label: 'Identifier',
    key: 'identifier'
  },
  {
    label: 'Radius',
    key: 'radius'
  },
  {
    label: 'Type',
    key: 'Type'
  },
  {
    label: 'Poi Type',
    key: 'poiType'
  },
  {
    label: 'Active',
    key: 'isActive'
  },
  {
    label: 'User Id',
    key: 'userId'
  },
  {
    label: 'Geocoding Option',
    key: 'geocodingOption'
  },
  {
    label: 'Pois Flow Code',
    key: 'poisFlowCode'
  },
  {
    label: 'Created At',
    key: 'createdAt',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'Updated At',
    key: 'updatedAt',
    formatter: 'dateFormatterTz'
  },
  {
    label: 'Action',
    key: 'action'
  },
]

export const DEFAULT_POI_FORM_RENDERING= {
  label: 'Default Poi Config',
  formKey: 'defaultPoiForm',
  options: {},
  desc: 'Use this form to create poi config',

  styles: {},
  formConfig: {
    '1': {
      data: [
        {
          formKey: 'identifier',
          validation: 'required',
          label: 'Identifier',
          type: 'local-select',
          placeholder: 'Select Identifier',
          apiUrl: '/api/v3/admin/default_poi_configs/fetch_config_default?type=identifier',
          options: null,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          searchQueryKey: 'content'
        },
        {
          formKey: 'radius',
          validation: null,
          label: 'Radius',
          type: 'text',
          placeholder: 'Enter radius',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'geocodingOption',
          validation: 'required',
          label: 'Geocoding Option',
          type: 'local-select',
          placeholder: 'Select',
          apiUrl: '/api/v3/admin/default_poi_configs/fetch_config_default?type=geocoding_option',
          options: null,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          searchQueryKey: 'content'
        },
        {
          formKey: 'Type',
          validation: "required",
          label: 'Type',
          type: 'local-select',
          placeholder: 'Select',
          apiUrl: '/api/v3/admin/default_poi_configs/fetch_config_default?type=_type',
          options: null,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          searchQueryKey: 'content'
        },
        {
          formKey: 'poiType',
          validation: 'required',
          label: 'Poi Type',
          type: 'local-select',
          placeholder: 'Select',
          apiUrl: '/api/v3/admin/default_poi_configs/fetch_config_default?type=poi_type',
          options: null,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          searchQueryKey: 'content'
        },
        {
          formKey: 'poisFlowCode',
          validation: null,
          label: 'Pois Flow Code',
          type: 'text',
          placeholder: 'Enter Pois Flow Code',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'minDwellTime',
          validation: null,
          label: 'Min Dwell Time',
          type: 'text',
          placeholder: 'Enter Min Dwell Time',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'maxWaitIfExited',
          validation: null,
          label: 'Max Wait If Exited',
          type: 'text',
          placeholder: 'Enter Max Wait If Exited',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'maxWaitIfInside',
          validation: null,
          label: 'Pois Max Wait If Inside',
          type: 'text',
          placeholder: 'Enter Max Wait If Inside',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
        {
          formKey: 'isActive',
          validation: null,
          label: 'Active',
          type: 'checkbox',
          placeholder: 'Enter Max Wait If Inside',
          row: 1,
          styling: { variant: { width: [1, 1 / 2, 1 / 3] } },
          dependency: null,
          options: null
        },
      ],
      style: {}
    },
  },
  btnConfig: {
    submitButton: {
      label: 'Submit',
      style: {},
      isDisplay: true
    },
    resetButton: {
      isDisplay: true,
      label: 'Reset',
      style: {}
    }
  }
}